<template>
  <div class="tg-page-root min-h-screen bg-gray-50 dark:bg-gray-950">
    <!-- Header -->
    <PageHeader :title="$t('PageTitle_ReturnPolicy')" @back="goBack" />

    <div class="px-4 py-4 max-w-lg mx-auto pb-8">
      <!-- 政策內容：依全局語言顯示，不限定高度 -->
      <div
        class="return-policy-content rounded-2xl bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 shadow-sm p-5"
      >
        <div
          class="policy-prose"
          v-html="policyContent"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import PageHeader from '@/components/PageHeader.vue'

const router = useRouter()
const { t } = useI18n()

const policyContent = computed(() => t('ReturnPolicy_Content'))

const goBack = () => {
  router.back()
}

</script>

<style scoped>
.return-policy-content {
  -webkit-overflow-scrolling: touch;
}

/* 政策內容排版：標題、段落、列表 */
.policy-prose :deep(h1) {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  margin-top: 1.25rem;
  margin-bottom: 0.5rem;
  line-height: 1.4;
}
.policy-prose :deep(h1:first-child) {
  margin-top: 0;
}
.policy-prose :deep(h2) {
  font-size: 1.0625rem;
  font-weight: 600;
  color: #1f2937;
  margin-top: 1.25rem;
  margin-bottom: 0.5rem;
  line-height: 1.4;
}
.policy-prose :deep(h2:first-child) {
  margin-top: 0;
}
.policy-prose :deep(h3) {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin-top: 1rem;
  margin-bottom: 0.375rem;
  line-height: 1.4;
}
.policy-prose :deep(p) {
  font-size: 0.9375rem;
  color: #4b5563;
  line-height: 1.65;
  margin-bottom: 0.75rem;
}
.policy-prose :deep(p:last-child) {
  margin-bottom: 0;
}
.policy-prose :deep(ul),
.policy-prose :deep(ol) {
  margin: 0.5rem 0 0.75rem 1.25rem;
  padding: 0;
}
.policy-prose :deep(li) {
  font-size: 0.9375rem;
  color: #4b5563;
  line-height: 1.65;
  margin-bottom: 0.375rem;
}
.policy-prose :deep(strong) {
  font-weight: 600;
  color: #374151;
}
.policy-prose :deep(code) {
  font-size: 0.8125rem;
  background: #f3f4f6;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  color: #374151;
}
</style>
